import React from 'react';

export default function Spinner({ texto = '' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 60, gap: 16 }}>
      <div style={{
        width: 36, height: 36, borderRadius: '50%',
        border: '3px solid #e5e5e5',
        borderTop: '3px solid #1a1a1a',
        animation: 'spin 0.8s linear infinite'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {texto && <div style={{ fontSize: 13, color: '#888' }}>{texto}</div>}
    </div>
  );
}
